<p>user-activation works!</p>
